import React from 'react'
import {
  TimePicker as MuiTimePicker,
  LocalizationProvider,
  TimePickerProps as MuiTimePickerProps
} from '@mui/x-date-pickers'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import { dateFnsLocale } from '../../../utils/localeUtils'

interface TimePickerProps {
  label?: string
  value: Date | null
  onChange: (selectedTime: Date | null, keyboardInputValue?: string) => void
  error?: boolean
  required?: boolean
  disabled?: boolean
  shouldDisableTime?: MuiTimePickerProps<Date, false>['shouldDisableTime']
  onError?: MuiTimePickerProps<Date, false>['onError']
  minutesStep?: number
}

function TimePicker({
                      label,
                      value,
                      onChange,
                      error,
                      required,
                      disabled,
                      shouldDisableTime,
                      onError,
                      minutesStep
                    }: TimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
      <MuiTimePicker
        label={label}
        value={value}
        onChange={(newValue: Date | null) => {
          onChange(newValue)
        }}
        ampm={false}
        ampmInClock={false}
        shouldDisableTime={shouldDisableTime}
        onError={onError}
        slotProps={{
          textField: {
            required,
            error,
            fullWidth: true
          },
          actionBar: {
            actions: ['accept', 'cancel'],
            sx: {
              '& .MuiDialogActions-root': {
                justifyContent: 'center',
                paddingBottom: 2
              },
              '& .MuiButton-root': {
                margin: '0 auto'
              }
            }
          }
        }}
        disabled={disabled}
        minutesStep={minutesStep}
      />
    </LocalizationProvider>
  )
}

export default TimePicker